export default __webpack_public_path__ + "static/media/auto.783b86bf.png";